import { useRef } from 'react';

const focusOnElement = (el: HTMLElement) => {
  let temp: HTMLElement | undefined;
  if (el.tagName === 'INPUT') {
    temp = document.createElement('input');
    temp.style.position = 'absolute';
    temp.style.left = `${el.offsetLeft}px`;
    temp.style.top = `${el.offsetTop}px`;
    temp.style.width = '0';
    temp.style.height = '0';
    temp.style.opacity = '0';
    document.body.appendChild(temp);
    temp.focus();
  }
  setTimeout(() => {
    el.focus();
    if (temp) {
      document.body.removeChild(temp);
    }
  }, 400);
};

export function useFocus() {
  const htmlElRef = useRef<HTMLInputElement>(null);
  const setFocus = () => {
    setTimeout(() => {
      if (typeof htmlElRef.current?.focus === 'function') {
        focusOnElement(htmlElRef.current);
      }
    }, 0);
  };

  return {
    htmlElRef,
    setFocus,
  };
}
